/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The version of this API, generated during maven build. This is for technical purposes only. May be used by the API consumer.
 */
export const SalesBridgeApiVersion = {
  ProjectVersion: '@project.version@',
} as const;
export type SalesBridgeApiVersion = (typeof SalesBridgeApiVersion)[keyof typeof SalesBridgeApiVersion];
